import React, { useState } from "react";

import { LivePanel } from "@demo/ui/LivePanel.js";
import { SpendLedger } from "@demo/ui/SpendLedger.js";
import { SPEND_GIG_CATALOG } from "@demo/live/gig-catalog-spend.js";
import { BEACON } from "./scenario/beacon.js";
import { BEACON_BUNDLES } from "./data.js";

// The Beacon app leads with an Overview — the spend statement / ledger, a
// distinct layout from the other demos' two-card hero — with the live seal
// behind a second tab. Everything below the masthead is shared UI driven by
// Beacon's copy; the recorded receipts the Overview verifies are four real
// resource_purchased packages (apps/spend-demo/src/data.ts).
type Mode = "overview" | "live";

export function App() {
  const [mode, setMode] = useState<Mode>("overview");

  return (
    <div className="page">
      <div className="disclosure-banner" role="note">
        <span className="disclosure-dot" aria-hidden="true" />
        <span>{BEACON.disclosure}</span>
      </div>

      <header className="masthead">
        <div className="brand">
          <span className="brand-mark" aria-hidden="true">
            {BEACON.client.mark}
          </span>
          <div>
            <div className="brand-name">{BEACON.client.name}</div>
            <div className="brand-domain">{BEACON.client.domain}</div>
          </div>
        </div>
        <div className="masthead-tag">{BEACON.masthead}</div>
      </header>

      <div className="mode-toggle" role="tablist" aria-label="Demo section">
        <button
          role="tab"
          aria-selected={mode === "overview"}
          className={"mode-toggle-btn" + (mode === "overview" ? " mode-toggle-btn-active" : "")}
          onClick={() => setMode("overview")}
        >
          Overview
        </button>
        <button
          role="tab"
          aria-selected={mode === "live"}
          className={"mode-toggle-btn" + (mode === "live" ? " mode-toggle-btn-active" : "")}
          onClick={() => setMode("live")}
        >
          Run live
        </button>
      </div>

      {mode === "overview" ? (
        <main className="content">
          <SpendLedger
            statement={BEACON.statement}
            bundles={BEACON_BUNDLES}
            ctas={[{ ...BEACON.liveCta, onClick: () => setMode("live") }]}
          />
        </main>
      ) : (
        <main className="content">
          <section className="intro">
            <h1>{BEACON.intro.headline}</h1>
            <p>{BEACON.intro.body}</p>
          </section>

          <LivePanel catalog={SPEND_GIG_CATALOG} copy={BEACON.live} />
        </main>
      )}

      <footer className="footer">
        <p>
          {BEACON.disclosure} Built on <span className="footer-link">{BEACON.product.name}</span>:{" "}
          {BEACON.product.tagline}.
        </p>
      </footer>
    </div>
  );
}
